import DailyBaseRateHelpTooltip from '@/components-internal/charts/DailyBaseRateHelpTooltip'
import DiscountFactorHelpTooltip from '@/components-internal/charts/DiscountFactorHelpTooltip'
import ChartOverwriteModalBase from '@/components-internal/charts/ChartOverwriteModalBase'

/**
 * Mixin for the overwrite modal
 */
export default {
  components: {
    ChartOverwriteModalBase,
    DailyBaseRateHelpTooltip,
    DiscountFactorHelpTooltip,
  },
  data() {
    return {
      /**
       * indicates the name of the active
       * tooltip -> used in the base slot for
       * the drawn tooltip
       */
      activeHelpBoxIdentifier: '',
    }
  },
  methods: {
    /**
     * open the overwrite modal
     * note: needs baseModal ref!
     */
    open() {
      this.$refs.baseModal?.openModal()
    },
    /**
     * open/close the help tooltip slot
     * note: needs baseModal ref!
     * @param value
     */
    openHelpTooltip(value = true, identifier) {
      if (value) {
        this.activeHelpBoxIdentifier = identifier
      } else {
        this.activeHelpBoxIdentifier = null
      }
      this.$refs.baseModal?.openHelpTooltip(value)
    },
  },
}
